import { styled } from '@mui/system'
import { alpha, CircularProgress, IconButton } from '@mui/material'

interface SidebarAlertsOpenButtonProps {
	readonly open?: boolean
}

const SidebarAlertsBadgeLoader = styled(CircularProgress)`
	position: absolute;
	top: -0.0625rem;
	right: -0.4rem;
	z-index: 1;
	border-radius: 50%;
`

const SidebarAlertsOpenButton = styled(IconButton, {
	shouldForwardProp: prop => prop !== 'open',
})<SidebarAlertsOpenButtonProps>(({ theme, open }) => ({
	fontSize: '2rem',
	width: '3rem',
	minWidth: '3rem',
	maxWidth: '3rem',
	marginTop: '2.25rem',
	marginLeft: '0.4rem',
	borderRadius: '0.625rem',
	paddingRight: '0.75rem',
	paddingLeft: '0.75rem',
	backgroundColor: open ? alpha(theme.palette.common.white, 0.1) : 'unset',
}))

export { SidebarAlertsBadgeLoader, SidebarAlertsOpenButton }
